import { render } from "./ChatBody.vue?vue&type=template&id=17427ad2"
import script from "./ChatBody.vue?vue&type=script&lang=js"
export * from "./ChatBody.vue?vue&type=script&lang=js"

import "./ChatBody.vue?vue&type=style&index=0&id=17427ad2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__